import React from "react";
import PuffLoader from "react-spinners/PuffLoader";
import ExpertCardComponent from "../component/ExpertCardComponent";
import NoExpertFound from "../../../components/NoExpertFound";
import Pagination from "../../../components/Pagination";

const itemsPerPage = 8;

const GenericExpertTabPage = ({getRefComment, expertTabData=[], loading }) => {

  //Filter expert data based on designation
  const filteredExperts = expertTabData.filter(
    (expert) => expert.ref_comment === getRefComment
  );

  return (
    <div>
      {loading ? (
        <div className="h-[30vh] w-full flex items-center justify-center">
          <PuffLoader color="#36d7b7" size={100} />
        </div>
      ) : (
        <div className="py-5 flex flex-col justify-center sm:flex-row flex-wrap gap-5">
          {(filteredExperts?.length ?? 0) === 0 ? (
            <NoExpertFound ref_comment={filteredExperts.ref_comment} />
          ) : (
            <Pagination
              items={filteredExperts}
              itemsPerPage={itemsPerPage}
              componentName={ExpertCardComponent}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GenericExpertTabPage;
